import React from 'react';
import { Combo, ComboProps } from '@fx-ui/fine-design';
import classNames from 'classnames';

interface IComboProps extends ComboProps {
    isView?: boolean; // 预览模式
}

const CustomCombo: React.FC<IComboProps> = (props) => {
    const { className, isView, disabled } = props;

    return (
        <Combo
            {...props}
            className={classNames('fx-custom-combo', className, { 'is-view': isView })}
            disabled={isView || disabled}
        />
    );
};

export default CustomCombo;
